module.exports = __webpack_public_path__ + "img/006-wind-8.349fc945.svg";